import React, { Component } from 'react'
import { Table, Skeleton, message } from 'antd'
import InfiniteScroll from 'react-infinite-scroller'

import AppContext from '../../../AppContext'
import ExpandMenuIcon from '../../../components/ui/general/icons/ExpandMenuIcon'
import PopoverButton from '../../../components/ui/general/buttons/PopoverButton'
import LoadingButton from '../../../components/ui/general/buttons/LoadingButton'
import CreateRoleModal from '../../../components/ui/dataEntry/other/CreateRoleModal'
import FixedTableHeader from '../../../components/ui/dataDisplay/FixedTableHeader'
import AdminItemConfirmModal from '../../../components/ui/feedback/AdminItemConfirmModal'
import { utilityService } from '../../../services/UtilityService'

import { graphql, withApollo } from '@apollo/client/react/hoc'
import _, { cloneDeep, flowRight as compose } from 'lodash'
import QueryRole from '../../../graphQL/admin/entertainmentData/listRole'
import MutationDeleteRole from '../../../graphQL/admin/entertainmentData/deleteRole'
import FilterInput from '../../../components/ui/dataEntry/inputs/FilterInput'

const deleteRoleMessage = {
  title: 'DELETE ROLE',
  firstMessage: 'Are you sure you want to delete this Role?',
  secondMessage: 'This action cannot be undone.'
}

const options = [
  {
    type: 'edit',
    name: 'Edit'
  }
]

class RoleList extends Component {
  constructor (props) {
    super(props)
    this.state = {
      openedRole: null,
      isLoading: !(props.roleList && props.roleList.length),
      showAddRoleModal: false,
      showDeleteRoleModal: false,
      selectedRole: undefined,
      deleteLoading: false,
      isDeleted: false,
      roleSearch: { searchString1: '', searchString2: '' }
    }
    this.columns = [
      {
        title: 'Roles',
        dataIndex: 'name',
        key: 'name',
        width: '37%',
        className: 'entertainment-data'
      },
      {
        title: 'Usage Count',
        dataIndex: 'usedCount',
        width: '50%',
        key: 'usedCount',
        render: (usedCount, { isError }) => this.renderUsedCount(usedCount, isError)
      },
      {
        key: 'id',
        dataIndex: 'id',
        width: '3%',
        render: (id) => this.renderData(id)
      }
    ]
  }

    componentDidMount = () => {
      document.addEventListener('mousedown', this.handleClickOutside)
    }

    UNSAFE_componentWillReceiveProps = newProps => { // eslint-disable-line camelcase
      if (!newProps.isLoading && !_.isEqual(newProps.roleList, this.props.roleList)) {
        this.setState({ isSearching: false, isPaginating: false, isLoading: false })
      } else if (!newProps.isLoading && this.props.isLoading && this.state.isSearching && _.isEqual(newProps.roleList, this.props.roleList)) {
        this.setState({ isSearching: false, isLoading: false })
      } else if (!newProps.isLoading && _.isEqual(newProps.roleList, this.props.roleList) && this.props.roleFilter && this.props.roleFilter.searchString) {
        this.setState({ isSearching: false, isLoading: false })
      } else if (!newProps.isLoading && _.isEmpty(newProps.roleList)) {
        this.setState({ isLoading: false })
      }
    }

    componentWillUnmount () {
      document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside = (event) => {
      const { target } = event
      const { className } = target
      const availableOptions = ['edit', 'delete']
      const isOptionClicked = availableOptions.findIndex(item => className === item)
      if (isOptionClicked > -1) {
        return
      }
      if (this.state.openedRole) {
        this.setState({ openedRole: null })
      }
    }

    toggleShowOptions = id => {
      if (this.state.openedRole === id) {
        this.setState({ openedRole: null })
      } else {
        this.setState({ openedRole: id })
      }
    }

    onSelectOption = (id, selectedOption) => {
      const { roleList } = this.props
      const selectedRole = roleList.find(item => item.id === id)
      if (!selectedRole) {
        return
      }
      if (selectedOption.type === 'edit') {
        this.setState({ showAddRoleModal: true, selectedRole })
      } else if (selectedOption.type === 'delete') {
        this.setState({ showDeleteRoleModal: true, selectedRole })
      }
      this.setState({ openedRole: null })
    }

    onRoleSelect = (selectedValue, field) => {
      if (field === 'to') {
        this.setState({ toSelectedRole: selectedValue })
      } else {
        this.setState({ fromSelectedROle: selectedValue })
      }
    }

    showAddRole = () => {
      this.setState({ showAddRoleModal: true })
    }

    hideAddRoleModal = () => {
      this.setState({ showAddRoleModal: false, selectedRole: null })
    }

    handleAddRole = () => {
      this.setState({ showAddRoleModal: false, selectedRole: null })
    }

    hideDeleteRoleModal = () => {
      this.setState({ isDeleted: true, selectedRole: null }, () => {
        this.setState({ showDeleteRoleModal: false, isDeleted: false })
      })
    }

    handleDeleteRole = () => {
      const { selectedRole } = this.state
      // const { onHistoryUpdate } = this.props
      if (!selectedRole) {
        return
      }
      this.setState({ deleteLoading: true })
      this.props.deleteRole(selectedRole.id, selectedRole.name).then(() => {
        message.success('Role deleted successfully')
        this.setState({ isDeleted: true, selectedRole: null }, () => {
          this.setState({ showDeleteRoleModal: false, deleteLoading: false, isDeleted: false })
        })
        // onHistoryUpdate()
      }, error => {
        this.setState({ isDeleted: true, selectedRole: null }, () => {
          this.setState({ showDeleteRoleModal: false, deleteLoading: false, isDeleted: false })
        })
        utilityService.handleError(error)
      })
    }

    onSearchOptions = (value, isFirst) => {
      let { roleSearch } = this.state
      if (isFirst) {
        roleSearch.searchString1 = value
      } else {
        roleSearch.searchString2 = value
      }
      this.setState({ roleSearch })
    }

    onChangeFilter = value => {
      this.setState({ isLoading: true, isSearching: true })
      this.props.onChangeRoleFilter({ searchString: value })
    }

    loadMoreAsset = () => {
      if (this.props.totalCount === this.props.roleList.length || this.state.isPaginating) { return }
      this.setState({ isPaginating: true }, () => this.props.getMoreRoles(this.props.roleList.length))
    }

    renderUsedCount = (count, isError) => {
      if (isError) {
        return <div>{'Error in Transfer. Retry'}</div>
      } else if (!count) {
        return '0'
      } else {
        return count
      }
    }

    renderData = (id) => {
      let availableOptions = _.cloneDeep(options)
      const { openedRole } = this.state
      const { roleList } = this.props
      const selectedRole = roleList.find(item => item.id === id)
      if (selectedRole && (!selectedRole.usedCount || !parseInt(selectedRole.usedCount)) && !this.isDeleteDisabled) {
        const deleteOption = {
          type: 'delete',
          name: 'Delete'
        }
        availableOptions.push(deleteOption)
      }
      if (!selectedRole.usedCount || !parseInt(selectedRole.usedCount)) {
        // availableOptions.splice(1, 1)
        if (this.isUpdateDisabled) {
          availableOptions.splice(0, 1)
        }
      } else if (this.isUpdateDisabled) {
        availableOptions.splice(0, 1)
      }
      if (availableOptions && availableOptions.length) {
        return (
          <div className='option-list' id='option-list'>
            <PopoverButton
              button={<div onClick={(e) => this.toggleShowOptions(id)} > <ExpandMenuIcon /> </div>}
              displayParam='name'
              contents={availableOptions}
              onContentClick={(selectedOption) => this.onSelectOption(id, selectedOption)}
              parentCompoent={'option-list'}
              isVisible={openedRole === id}
              placement={'leftBottom'}
            />
          </div>
        )
      } else {
        return null
      }
    }

    render () {
      const { roleList, roleFilter, onHistoryUpdate } = this.props
      const { isLoading, isPaginating, showAddRoleModal, showDeleteRoleModal, selectedRole, deleteLoading, isDeleted } = this.state
      let adminItem
      if (selectedRole && showDeleteRoleModal) {
        adminItem = <div >
          <p>{ selectedRole.name }</p>
        </div>
      }
      return (
        <AppContext.Consumer>
          {({ permissions, project }) => {
            const userPermissions = permissions['DATA_MANAGER']
            const isCreateDisabled = userPermissions.indexOf('CREATE') === -1
            this.isDeleteDisabled = userPermissions.indexOf('DELETE') === -1
            this.isUpdateDisabled = userPermissions.indexOf('UPDATE') === -1
            return <div className='admin-portal entertainment-list'>
              <FilterInput
                searchString={roleFilter.searchString}
                onChangeSearchInput={this.onChangeFilter}
                placement='rightTop'
                project={project}
              />
              <div className='admin-list role-list'>
                <FixedTableHeader columnCellList={this.columns} />
                <InfiniteScroll
                  pageStart={0}
                  loadMore={this.loadMoreAsset}
                  hasMore={this.props.totalCount > roleList.length}
                  initialLoad={false}
                  useWindow={false}
                >
                  <Skeleton active avatar={false} title paragraph={{ rows: 6 }} loading={isLoading}>
                    <Table className={`general-table ${isPaginating ? 'paginating' : ''}`} rowKey={record => record.id} columns={this.columns} dataSource={roleList} pagination={false} />
                  </Skeleton>
                  <Skeleton active avatar={false} title paragraph={{ rows: 1 }} loading={isPaginating} />
                </InfiniteScroll>
              </div>
              <div className='admin-footer' >
                <LoadingButton
                  type='primary'
                  onClick={this.showAddRole}
                  htmlType='submit'
                  buttonText={'New'}
                  buttonClass='save-btn'
                  isLoading={false}
                  isDisabled={isCreateDisabled}
                />
              </div>
              <CreateRoleModal
                isVisible={showAddRoleModal}
                handleCancel={this.hideAddRoleModal}
                handleSubmit={this.handleAddRole}
                selectedRole={selectedRole}
                listApi module='DATA_MANAGER'
                isSubmitDisabled={_.isEmpty(selectedRole) ? isCreateDisabled : this.isUpdateDisabled}
                onHistoryUpdate={onHistoryUpdate}
                isDeleted={isDeleted}
                searchString={roleFilter.searchString}
                project={project}
              />
              <AdminItemConfirmModal
                isVisible={showDeleteRoleModal}
                title={deleteRoleMessage.title}
                firstMessage={deleteRoleMessage.firstMessage}
                secondMessage={deleteRoleMessage.secondMessage}
                adminItem={adminItem}
                rightButtonText={'Delete'}
                handleCancel={this.hideDeleteRoleModal}
                handleSubmit={this.handleDeleteRole}
                isSubmitButtonDisabled={this.isDeleteDisabled}
                isCancelButtonDisabled={false}
                isLoading={deleteLoading} />
            </div>
          }}
        </AppContext.Consumer>
      )
    }
}

RoleList.propTypes = {}

export default withApollo(compose(
  graphql(
    QueryRole,
    {
      options: ({ roleFilter, project }) => {
        const { searchString } = roleFilter
        const search = searchString ? { keyword: searchString, fields: ['name'] } : null
        const variables = { search, offset: 0, limit: 20, project: project }
        return {
          fetchPolicy: 'network-only',
          variables
        }
      },
      props: (props) => {
        const { data } = props
        let roleList = data.listRoles ? data.listRoles.items : []
        roleList = roleList.map(item => {
          if (item.isTransferring) {
            item.usedCount = 'Transferring'
          }
          return item
        })
        return {
          roleList,
          isLoading: data.loading || !data.listRoles,
          totalCount: data.listRoles ? data.listRoles.totalCount : 0,
          getMoreRoles: (page) => {
            return data.fetchMore({
              fetchPolicy: 'network-only',
              variables: {
                offset: page
              },
              updateQuery: (previous, { fetchMoreResult }) => {
                if (!fetchMoreResult) return previous
                const prev = cloneDeep(previous)
                const newList = [...prev.listRoles.items, ...fetchMoreResult.listRoles.items]
                prev.listRoles.items = newList
                return prev
              }
            })
          }
        }
      }
    }
  ),
  graphql(
    MutationDeleteRole, {
      options: ({ roleFilter, project }) => ({
        update: (cache, { data: { deleteRole } }) => {
          const { searchString } = roleFilter
          const search = searchString ? { keyword: searchString, fields: ['name'] } : null
          const variables = { search, offset: 0, limit: 20, project }
          const cacheData = _.cloneDeep(cache.readQuery({ query: QueryRole, variables }))
          if (cacheData && cacheData.listRoles && cacheData.listRoles.items) {
            const selectedIndex = cacheData.listRoles.items.findIndex(item => item.id === deleteRole.id)
            if (selectedIndex > -1) {
              cacheData.listRoles.items.splice(selectedIndex, 1)
              cacheData.listRoles.totalCount = cacheData.listRoles.totalCount - 1
            }
          }
          cache.writeQuery({
            query: QueryRole,
            data: cacheData,
            variables
          })
        }
      }),
      props: (props) => ({
        deleteRole: (id, name) => {
          return props.mutate({
            variables: { id, name, project: props.ownProps.project }
          })
        }
      })
    }
  )
)(RoleList))
